import React, { useState } from "react";
import {
  Box,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  TextField,
  Grid,
} from "@mui/material";

const TodayCustomerReport = () => {
  const [date, setDate] = useState("");

  const handleSearch = () => {
    console.log("Fetching report for date:", date);
  };

  return (
    <Box sx={{ maxWidth: "1200px", mx: "auto", py: 4, minHeight: "100vh", px: 2 }}>
      {/* Header */}
      <Paper elevation={3} sx={{ p: 2 }}>
        <Typography variant="h6" sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          Today Send SMS Report
        </Typography>
      </Paper>

      {/* Filters */}
      <Box mt={3}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={6} md={4}>
            <Typography sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <i className="fa fa-calendar"></i> From
            </Typography>
            <TextField
              type="date"
              size="small"
              fullWidth
              value={date}
              onChange={(e) => setDate(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={2} mt={3}>
            <Button variant="contained" color="primary" fullWidth onClick={handleSearch}>
              <i className="fa fa-search" aria-hidden="true"></i> Search Now
            </Button>
          </Grid>
        </Grid>
      </Box>

      {/* Table */}
      <TableContainer component={Paper} sx={{ mt: 3, overflowX: "auto" }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>CustName</TableCell>
              <TableCell>Total Submit</TableCell>
              <TableCell>Total Delivered</TableCell>
              <TableCell>Total Failed</TableCell>
              <TableCell>Total Pending</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>Self</TableCell>
              <TableCell>0</TableCell>
              <TableCell>0</TableCell>
              <TableCell>0</TableCell>
              <TableCell>0</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default TodayCustomerReport;
